import { render, staticRenderFns } from "./NoSummary.vue?vue&type=template&id=50523800&"
import script from "./NoSummary.vue?vue&type=script&lang=ts&"
export * from "./NoSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports